import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

/**
 * WhatsAppButton Component - DARK EDITION
 * A high-visibility floating action button optimized for black backgrounds.
 */
const WhatsAppButton = ({ lang = 'en', phone = '96550097296' }) => {
  const isAr = lang === 'ar';

  const handleClick = () => {
    const message = encodeURIComponent(
      isAr
        ? 'مرحباً رايت تشويس للرعاية الصحية، أود الاستفسار عن خدماتكم.'
        : 'Hello Right Choice Health Care, I would like to inquire about your services.',
    );
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <div
      className={`fixed bottom-8 ${isAr ? 'left-8' : 'right-8'} z-[100] flex items-center justify-center group`}
    >
      {/* Pulse Effect Animation - Adjusted opacity for black background */}
      <span className='absolute inline-flex h-16 w-16 animate-ping rounded-full bg-green-500 opacity-10'></span>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={handleClick}
        aria-label='Contact us on WhatsApp'
        className='relative flex h-16 w-16 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_0_30px_rgba(37,211,102,0.3)] transition-all hover:bg-[#20ba5a]'
      >
        <MessageCircle size={32} fill='currentColor' />

        {/* Notification Dot - Border changed to match dark theme */}
        <span
          className={`absolute top-0 ${isAr ? 'left-0' : 'right-0'} flex h-4 w-4`}
        >
          <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75'></span>
          <span className='relative inline-flex rounded-full h-4 w-4 bg-red-500 border-2 border-[#050505]'></span>
        </span>

        {/* Tooltip - Adjusted for Dark Mode Contrast */}
        <span
          className={`absolute ${
            isAr ? 'right-20' : 'left-20'
          } opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap bg-white/10 backdrop-blur-md text-white border border-white/10 text-[10px] font-black uppercase tracking-widest px-4 py-2 rounded-lg shadow-2xl`}
        >
          {isAr ? 'تواصل معنا' : 'Contact Us'}
        </span>
      </motion.button>
    </div>
  );
};

export default WhatsAppButton;
